module.exports = __webpack_public_path__ + "static/media/moving@2x.66a01158.png";